<template>
  <div>
    <public-title v-if="behalf">设置代收款</public-title>
    <public-title v-else-if="orderConfirm">{{orderConfirmSend?'发布确认订单':'修改确认订单'}}</public-title>
    <public-title v-else>{{modify?'修改订单':'发布询价'}}</public-title>
    <div class="load-area" v-if="!loading">
      <!--内容框-->
      <div class="category-switch">
         <!--分类切换列表-->
        <div class=" justify-content-between">
          <div v-for="item in categoryList" :key="item.id" class="category-item"  :class="{'active':categoryid === item.id}" @click="$router.push({query:{...$route.query,type:item.id }})">
            <img :src="item.img" alt="">
            <div class="category-item-content">
              <p>{{orderConfirm?item.confirmName:item.name}}</p>
              <span>{{item.quantity}}</span>
            </div>
            <i class="el-icon-success" v-if="categoryid === item.id"></i>
          </div>
        </div>
        <!--住宿订单-->
        <room v-show="categoryid === 1" :orderDetail="orderDetail" :modify="modify" @submitForm="submitForm" :isHotelInquiry="isHotelInquiry" :orderConfirm="orderConfirm" :orderConfirmSend="orderConfirmSend"></room>
        <!--存会议订单(不住宿)-->
        <meeting v-show="categoryid === 2" :orderDetail="orderDetail" :modify="modify" @submitForm="submitForm" :isHotelInquiry="isHotelInquiry" :orderConfirm="orderConfirm" :orderConfirmSend="orderConfirmSend"></meeting>
      </div>
      <!--询价酒店-->
      <HotelInquiry :orderConfirm="orderConfirm" :orderConfirmList="orderConfirmList" @updateAppointUid="updateAppointUid" @judgmentInquiry="judgmentInquiry" v-if="isHotelInquiry||orderConfirmSend" ></HotelInquiry>
      <!--确认订单弹出框-->
      <ConfirmPanel ref="ConfirmPanel" :orderConfirm="orderConfirm" :orderConfirmSend="orderConfirmSend" :orderDetail="formData" :modify="modify" :behalf="behalf" :confirmPanelShow="confirmPanelShow" @placeAnOrder="placeAnOrder" @onShow="confirmPanelShow=false"></ConfirmPanel>
    </div>
    <!--发布订单加载提示框-->
    <!--报价弹窗-->
    <div class="load-area loading" v-else>  
      <div class="loading-img">
        <img :src="`/images/orderState/state_${loadingSuccess?4:7}.jpg`" alt=""/>
      </div>
      <p class="mt-2" v-if="!modify||orderConfirmSend">{{loadingSuccess?'订单发布成功':'订单发布中~'}}</p>
      <p class="mt-2" v-else-if="modify">{{loadingSuccess?'订单修改成功':'订单修改中~'}}</p>
          <!--操作按钮-->
      <div   class="order-bottoms mt-4" v-if="loadingSuccess">
          <el-button  v-if="storeInfo.type==2" type="warning" class="bottom" icon="el-icon-document-copy" @click="$router.go(0)">继续发布</el-button>
          <el-button  type="primary" class="bottom"  icon="el-icon-view" @click="goForDetail">查看详情</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState,mapActions,mapMutations,mapGetters} from 'vuex'
  import HotelInquiry from './Components/HotelInquiry' //公共标题
  import Room from './Room'                            //住宿订单
  import Meeting from './Meeting'                      //会议订单
  import ConfirmPanel from './ConfirmPanel'  //确认订单
  export default {
  name: 'OrderPost',
  components: {Room,Meeting,HotelInquiry,ConfirmPanel},
  props: {},
  data() {
    return {
      //分类切换
      // categoryid: 1,
      //分类切换列表
      categoryList: [
        {
          id: 1,
          name: '住宿询价',
          confirmName: '住宿确认',
          quantity:'团队预订 舒适安心住宿',
          img:'/images/order/icon_18.png'
        },
        {
          id: 2,
          name: '纯会询价',
          confirmName: '纯会确认',
          quantity:'专注会议 不含住宿安排',
          img:'/images/order/icon_19.png'
        },
      ],
      appoint_uid: '',                   //业务人员指定ID
      orderDetail: {},                   //订单详情详情
      confirmPanelShow:false,            //是否显示确认单
      //提交订单数据
      formData:{},
      //发布订单加载提示框
      loading:false,
      //发布成功状态
      loadingSuccess:false,
      //发布成功订单ID
      loadingOrderId: '',
      //修改酒店ID
      store_id:'',
      //确认订单酒店列表
      orderConfirmList:[],
    };
  },
  computed: {
    ...mapGetters(['storeInfo']),
    ...mapState(['inquiryList','confirmid']),
    //判断是否是询价酒店
    isHotelInquiry: {
      get() {
        return this.$route.query.isHotelInquiry&&this.inquiryList.length>0?true : false
      },
      set(val) {
        return val
      }
    },
    //判断是否是修改订单
    modify() { return this.$route.query.modify?true : false },
    //判断是否是确认订单
    orderConfirm() { return this.$route.query.orderConfirm?true : false },
    //判断是否是发布的确认单
    orderConfirmSend() { return this.$route.query.orderConfirmSend?true : false },
    //修改订单ID
    orderId() { return  this.$route.query.orderId||'' }, 
    //设置代收款标识
    behalf() { return  this.$route.query.behalf||'' },  
    //订单类型
    categoryid() { return  Number(this.$route.query.type)||1},  
  },
  watch: {},
  created() {},
  mounted() {
      //如果是修改订单且不是确认单获取详情
      if(this.modify&&!this.orderConfirmSend){
        this.getModifyOrderDetail();
      }
      //如果是发布确认订单获取详情
      if(this.orderConfirmSend){
        this.getConfirmOrderDetail();
      }
  },
  methods: {
    //更新酒店询价信息
    ...mapMutations(['UPDATEINQUIRYLISTINFO']),
    ...mapActions(['POST_OrderHotelDetail','POST_HotelsMeetingList','POST_HotelsRoomList','POST_SendOrderHotel','POST_travelPostOrder','POST_SetOrderHotelBroker','deleteShare','GetDisplayInfo','POST_SendOrderHotelConfirm']),
    //获取订单详情
    getModifyOrderDetail(){
      let POST=this.behalf==2?this.deleteShare:this.POST_OrderHotelDetail;
      POST({data:{oid:this.orderId}}).then(res => {
        res.info.hotel_breakfast_type=res.select_hotel?res.select_hotel.breakfast_type:res.breakfast;
        this.orderDetail=res.info;
        this.store_id=res.info.store_id || res.info.offer_store_id||res.info.appoint_store_id;
        let data={
          hotel_id:res.info.offer_store_id||res.info.appoint_store_id,
        }
        //获取修改时会议室列表信息
        this.POST_HotelsMeetingList(data)
        //获取修改时房间列表信息
        this.POST_HotelsRoomList(data)
      })
    },
    //确认订单获取酒店详情
    getConfirmOrderDetail(){
        console.log(this.storeInfo);  
        this.GetDisplayInfo({
            type:'3',
            data: {
              store_id: this.confirmid || this.storeInfo.storeId,
            },
            successFun:(e) => {
              this.orderConfirmList.push(e)
            }
        })
        let data={
          hotel_id:this.confirmid || this.storeInfo.storeId,
        }
        //获取确认时会议室列表信息
        this.POST_HotelsMeetingList(data)
        //获取确认时房间列表信息
        this.POST_HotelsRoomList(data)
    },
    //判断是否是询价酒店
    judgmentInquiry(){
      this.isHotelInquiry=false;
    },
    //更新业务人员id
    updateAppointUid(e){
      this.appoint_uid = this.$_Array.getFieldStr(e,'uid');
    },
    //确认订单
    async submitForm(formData){
      formData=JSON.parse(JSON.stringify(formData)); //深拷贝
      if(formData.order_type==1&&!this.modify||this.orderConfirm){
        //日期转秒级时间
        formData.date_out = this.$_Time.convertMsToSec(formData.date_in[1]);
        formData.date_in = this.$_Time.convertMsToSec(formData.date_in[0]);
      }
      //多晚入住-时间变转秒级
      if(formData.need_mode==1){
          formData.room_need.forEach(user=>{
              user.date=this.$_Time.convertMsToSec(user.date);
          })
      };
      formData.meeting_need.forEach(user=>{
            user.date=this.$_Time.convertMsToSec(user.date);
      })
      //清空对象中 undefined、null、空字符串 等无效属性
      formData=this.$_Object.removeEmptyProps(formData,['deposit']);
      //所有的数组转为','号隔开
      formData=this.$_Array.convertObjArrayToStr(formData, ',', ['room_need','meeting_need','discount_need','add_need']);
      //如果是修改订单
      // if(this.modify){
      //   formData.order_id=this.orderId;
      // }
      this.confirmPanelShow=true;
      this.formData=formData;
    },
    //发布订单
    async placeAnOrder(res){
      let formData=JSON.parse(JSON.stringify(this.formData)); //深拷贝
      this.confirmPanelShow=false;
      this.loading=true;
      //封装结构
      [
      ['room_need', 'room_need'],
      ['meeting_need', 'meeting_need'],
      ['discount_need', 'discount_need'],
      ['add_need', 'add_need']
      ].forEach(([src, tar]) => {
      const arr = formData[src]
      if (Array.isArray(arr) && arr.length > 0) {
          formData[tar] = JSON.stringify({
          mode: src=='room_need'||src=='discount_need'?1:0,
          list: arr
          })
      }
      })
      //******************发布确认订单*******************
      if(this.orderConfirm){
          formData.appoint_store_id=this.confirmid || this.storeInfo.storeId;
          formData.appoint_uid=this.appoint_uid;
          if(!this.orderConfirmSend){
            //订单ID
            formData.oid=this.orderId;
          }
          this.POST_SendOrderHotelConfirm({data:formData,modify:this.orderConfirmSend?false:true,
            successFun:(e) => {
              console.log(e,'确认单发布后的订单ID');
              this.loadingOrderId=e.oid;
              //订单发布成功
              this.loadingSuccess=true;
              let query={}
              if(!this.orderConfirmSend){
                  query.modify=1
              }
              this.$router.push({
                name: 'OrderDetail',
                query:{
                  orderId:e?e.oid:this.orderId,
                  ...query
                }
              });
          }});

        return;
      };
      //******************发布订单*******************
      if(!this.modify){
        //定向或多家询价询价
        if(this.isHotelInquiry){
          if(this.inquiryList.length==1){
            console.log(this.inquiryList);
            formData.appoint_store_id=this.inquiryList[0].id;
            formData.appoint_uid=this.appoint_uid;
          }else{
            formData.store_ids=this.inquiryList.map(item=>item.id).join(',');
          }
        }
       this.POST_SendOrderHotel({data:formData,successFun:(e) => {
          //发布成功时清楚询价酒店列表
          if(this.isHotelInquiry){
            this.UPDATEINQUIRYLISTINFO({infoList:'',modify:'clear'});
          }
          this.loadingOrderId=e.oid;
          //订单发布成功
          this.loadingSuccess=true;
        }});

      //******************修改订单*******************
      }else{
        //订单ID
        formData.oid=this.orderId;
        //酒店修改
        if(this.storeInfo.type==3){
          //通知人
          formData.flag=res?res.flag:0;
        }
        //定金
        formData.deposit=0;
        //******************设置代收款*******************
        let POST=this.behalf?this.POST_SetOrderHotelBroker:this.POST_travelPostOrder;
        let res = await POST(formData);
        //订单已经在确认期间返回详情
        this.loadingOrderId=this.orderId;
        if(res.code=='31062'){
          this.goForDetail(2);
          return;
        };
        if(res.code=='00000'){
          this.goForDetail(1);
        }
      }
    },
    /*跳转查看订单详情页*/
    goForDetail(i) {
      let query={
        orderId: this.loadingOrderId,
      }
      if(this.modify){
        query.modify=this.behalf?3:i
      }
      this.$router.push({
        name: 'OrderDetail',
        query:query
      });
    },
  }
};
</script>

<style lang="scss" scoped>
 .load-area{
    display: flex;
    justify-content: center;
 }
 .category-switch{
    width: 1000px;
    position: relative;
 }
 .justify-content-between{
    width: 100%;
    display: flex;
    justify-content: space-between;
    background-color: #fff;
    box-shadow: -2px 0 30px 2px rgba(97, 105, 119, 0.18);
    border-radius: 6px;
    overflow: hidden;
    .category-item{
      cursor: pointer;
      display: flex;
      width: 50%;
      padding: 2%;
      img{
        width: 40px;
        height: 40px;
      }
      .category-item-content{
        text-align: left;
        margin-left: 20px;
        margin-top: 0px;
        span{
          color: var(--smtc-color-text-shallow);
          font-size: 12px;
          margin-top: 2px;
          display: block;
        }
      }
    }
    .active{
      background-color: var(--smtc-color-primary);
      color: var(--smtc-color-text-white);
      span{
        color: var(--smtc-color-text-white) !important;
      }
    }
 }
  .el-icon-success{
      font-size: 40px;
      margin-left: auto;
  }
  .loading{
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
  .loading-img{
    display: block;
    margin: 0 auto;
    width: 160px;
    height: 160px;
    margin-top: -220px;
    background-color: #fff;
    border-radius: 50%;
    overflow: hidden;
    text-align: center;

  }
  .loading img{
    width: 120px;
    height: 120px;
    margin-top: 20px;
  }
</style>